var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolAdherenceTabActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 9.99997L9.20188 14.0176C9.3112 14.0722 9.36586 14.0996 9.42319 14.1103C9.47397 14.1198 9.52607 14.1198 9.57685 14.1103C9.63419 14.0996 9.68884 14.0722 9.79816 14.0176L17.8334 9.99997M1.16669 14.1666L9.20188 18.1842C9.3112 18.2389 9.36586 18.2662 9.42319 18.277C9.47397 18.2865 9.52607 18.2865 9.57685 18.277C9.63419 18.2662 9.68884 18.2389 9.79816 18.1842L17.8334 14.1666M1.16669 5.83331L9.20188 1.81571C9.3112 1.76105 9.36586 1.73372 9.42319 1.72297C9.47397 1.71344 9.52607 1.71344 9.57685 1.72297C9.63419 1.73372 9.68884 1.76105 9.79816 1.81571L17.8334 5.83331L9.79816 9.8509C9.68884 9.90556 9.63419 9.93289 9.57685 9.94365C9.52607 9.95317 9.47397 9.95317 9.42319 9.94365C9.36586 9.93289 9.3112 9.90556 9.20188 9.8509L1.16669 5.83331Z",
    stroke: "#1C4E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolAdherenceTabActive);
export default __webpack_public_path__ + "static/media/tool_adherence_tab_active.b73922ec4ec0e1f440c754e733246a64.svg";
export { ForwardRef as ReactComponent };